module.exports = __webpack_public_path__ + "static/media/step3.dfe39faa.png";